var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTransferIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.48862 7.69227C3.23014 7.69283 3.01861 7.89964 3.01911 8.15335L3.01538 9.93537L20.4638 9.93391L20.4632 9.92699C20.4496 9.79237 20.3555 8.85516 20.2928 8.76404L15.9363 2.30365C15.7272 1.99795 15.3048 1.91937 14.9951 2.12639L13.8077 2.91546C13.4962 3.12248 13.668 3.28335 13.8772 3.58736L15.2095 5.5L15.8757 6.45632L16.7528 7.69227L3.48862 7.69227Z",
    fill: "#6B6B6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9752 14.2793C20.2337 14.2787 20.4452 14.0719 20.4447 13.8182L20.4485 12.0362L2.99999 12.0376L3.00068 12.0446C3.0142 12.1792 3.10831 13.1164 3.17104 13.2075L7.52755 19.6679C7.73666 19.9736 8.15899 20.0522 8.46875 19.8452L9.65615 19.0561C9.96763 18.8491 9.79579 18.6882 9.58669 18.3842L8.25432 16.4716L7.58814 15.5152L6.71106 14.2793L19.9752 14.2793Z",
    fill: "#6B6B6B"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTransferIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/transferIcon.929ada209a8644077c0786df9eeaca6b.svg";